// PROSPECT on-site AI-discoverability checker — self-contained vanilla JS.
// Injects its own styles + an inline section, and calls the /api/audit Netlify
// function (netlify/functions/audit.mjs). NO tokens: the audit is pure
// fetch+parse+score on the server. Bundled into the site by Parcel via the
// <script> tag in index.html.
(function() {
    'use strict';
    var API_URL = '/api/audit';
    var ja = document.documentElement.lang ? document.documentElement.lang.toLowerCase().indexOf('ja') === 0 : (navigator.language || 'ja').toLowerCase().indexOf('ja') === 0;
    var T = ja ? {
        heading: "\u3042\u306A\u305F\u306E\u30B5\u30A4\u30C8\u306F\u3001AI\u306B\u898B\u3064\u3051\u3066\u3082\u3089\u3048\u307E\u3059\u304B\uFF1F",
        sub: "URL\u3092\u5165\u529B\u3059\u308B\u3068\u3001ChatGPT\u30FBClaude\u30FBPerplexity \u306A\u3069\u306EAI\u304C\u3042\u306A\u305F\u306E\u30B5\u30A4\u30C8\u3092\u3069\u308C\u3060\u3051\u300C\u898B\u3064\u3051\u30FB\u7406\u89E3\u30FB\u63A8\u85A6\u300D\u3067\u304D\u308B\u304B\u3092\u7121\u6599\u3067\u8A3A\u65AD\u3057\u307E\u3059\uFF08\u6570\u5341\u79D2\uFF09\u3002",
        placeholder: "https://\u3042\u306A\u305F\u306E\u30B5\u30A4\u30C8.jp",
        button: "\u7121\u6599\u3067\u8A3A\u65AD\u3059\u308B",
        checking: "\u8A3A\u65AD\u4E2D\u2026",
        scoreLabel: "AI\u767A\u898B\u6027\u30B9\u30B3\u30A2",
        gapsLabel: "\u691C\u51FA\u3057\u305F\u4E3B\u306A\u6539\u5584\u70B9",
        fixLine: "\u3053\u308C\u3089\u306F\u4EBA\u306B\u306F\u898B\u3048\u306B\u304F\u3044\u3082\u306E\u306E\u3001AI\u304C\u8CB4\u793E\u3092\u63A8\u85A6\u3059\u308B\u59A8\u3052\u306B\u306A\u308A\u307E\u3059\u3002Web\u30B5\u30A4\u30C8\u306E\u518D\u69CB\u7BC9\u3067\u89E3\u6D88\u3067\u304D\u307E\u3059\u3002",
        cta: "\u7121\u6599\u3067\u8A73\u7D30\u8A3A\u65AD\u30FB\u3054\u76F8\u8AC7",
        unreachable: "\u30B5\u30A4\u30C8\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002URL\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\uFF08\u516C\u958B\u30B5\u30A4\u30C8\u306E\u307F\u5BFE\u5FDC\uFF09\u3002",
        error: "\u8A3A\u65AD\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u6642\u9593\u3092\u304A\u3044\u3066\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
        outOf: '/ 100'
    } : {
        heading: 'Can AI find your website?',
        sub: "Enter your URL for a free check of how well AI assistants (ChatGPT, Claude, Perplexity\u2026) can find, read and recommend your site. Takes a few seconds.",
        placeholder: 'https://your-site.com',
        button: 'Run free check',
        checking: "Checking\u2026",
        scoreLabel: 'AI-discoverability score',
        gapsLabel: 'Top things to fix',
        fixLine: "These are hard for a human to spot but hold back how AI recommends you \u2014 a website rebuild fixes them.",
        cta: 'Get a free detailed audit',
        unreachable: 'Could not fetch that site. Please check the URL (public sites only).',
        error: 'The check failed. Please try again in a moment.',
        outOf: '/ 100'
    };
    function injectStyles() {
        var css = '.pa-section{padding:60px 20px;background:linear-gradient(to top left,#eafaf1,#f7fdf9);font-family:"Poppins",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}.pa-wrap{max-width:760px;margin:0 auto;text-align:center}.pa-h{font-size:26px;font-weight:600;color:#1a1a1a;margin:0 0 10px}.pa-sub{font-size:15px;line-height:1.7;color:#4a4a4a;margin:0 0 24px}.pa-form{display:flex;gap:10px;justify-content:center;flex-wrap:wrap}.pa-input{flex:1;min-width:240px;max-width:440px;padding:13px 15px;font-size:15px;font-family:inherit;border:1px solid #cfe6d8;border-radius:10px;outline:none}.pa-input:focus{border-color:#39b385;box-shadow:0 0 0 3px rgba(57,179,133,.15)}.pa-btn{padding:13px 22px;font-size:15px;font-weight:600;font-family:inherit;color:#fff;background:#0a7d4d;border:none;border-radius:10px;cursor:pointer;transition:transform .12s ease,background .2s}.pa-btn:hover{background:#0b8f58;transform:translateY(-1px)}.pa-btn:disabled{opacity:.6;cursor:default;transform:none}.pa-result{margin-top:26px;background:#fff;border:1px solid #e5efe9;border-radius:14px;box-shadow:0 6px 26px rgba(0,0,0,.06);padding:24px;text-align:left;display:none}.pa-result.pa-show{display:block}.pa-scorebar{display:flex;align-items:center;gap:18px;flex-wrap:wrap}.pa-ring{width:96px;height:96px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-direction:column;flex:none;color:#fff;font-weight:700}.pa-ring b{font-size:30px;line-height:1}.pa-ring span{font-size:11px;font-weight:500;opacity:.9}.pa-scoremeta{flex:1;min-width:200px}.pa-scoremeta h4{margin:0 0 4px;font-size:14px;color:#6b7280;font-weight:500}.pa-scoremeta .pa-url{font-size:15px;color:#111;font-weight:600;word-break:break-all}.pa-gaps{margin:20px 0 0;padding:0;list-style:none}.pa-gaps li{position:relative;padding:8px 0 8px 26px;font-size:14px;line-height:1.6;color:#333;border-top:1px solid #f0f4f2}.pa-gaps li:before{content:"!";position:absolute;left:0;top:8px;width:18px;height:18px;border-radius:50%;background:#fff3d6;color:#b8860b;font-size:12px;font-weight:700;text-align:center;line-height:18px}.pa-gapslabel{font-size:13px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-top:20px}.pa-fix{margin:18px 0 16px;font-size:14px;line-height:1.7;color:#374151}.pa-cta{display:inline-block;padding:12px 22px;font-size:15px;font-weight:600;color:#fff;background:linear-gradient(to top left,#39b385,#0a7d4d);border:none;border-radius:10px;cursor:pointer;text-decoration:none}.pa-msg{font-size:14px;color:#b91c1c;margin-top:14px}';
        var el = document.createElement('style');
        el.textContent = css;
        document.head.appendChild(el);
    }
    function scoreColor(s) {
        if (s >= 70) return '#2f9e6f';
        if (s >= 40) return '#d9a300';
        return '#e0575f';
    }
    function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
    }
    function render() {
        var section = el('section', 'pa-section');
        section.id = 'ai-audit';
        var wrap = el('div', 'pa-wrap');
        wrap.appendChild(el('h2', 'pa-h', T.heading));
        wrap.appendChild(el('p', 'pa-sub', T.sub));
        var form = el('form', 'pa-form');
        var input = el('input', 'pa-input');
        input.type = 'text';
        input.placeholder = T.placeholder;
        input.setAttribute('aria-label', T.placeholder);
        var btn = el('button', 'pa-btn', T.button);
        btn.type = 'submit';
        form.appendChild(input);
        form.appendChild(btn);
        wrap.appendChild(form);
        var result = el('div', 'pa-result');
        wrap.appendChild(result);
        section.appendChild(wrap);
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            run(input.value.trim(), btn, result);
        });
        return section;
    }
    function run(url, btn, result) {
        if (!url) return;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = T.checking;
        result.className = 'pa-result';
        result.innerHTML = '';
        fetch(API_URL, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                url: url
            })
        }).then(function(r) {
            return r.json().then(function(d) {
                return {
                    status: r.status,
                    data: d
                };
            });
        }).then(function(res) {
            btn.disabled = false;
            btn.textContent = original;
            if (res.status !== 200 || res.data.error) {
                showMsg(result, res.data.error || T.error);
                return;
            }
            if (!res.data.reachable) {
                showMsg(result, T.unreachable);
                return;
            }
            showResult(result, res.data);
        }).catch(function() {
            btn.disabled = false;
            btn.textContent = original;
            showMsg(result, T.error);
        });
    }
    function showMsg(result, msg) {
        result.innerHTML = '';
        result.appendChild(el('p', 'pa-msg', msg));
        result.className = 'pa-result pa-show';
    }
    function showResult(result, data) {
        result.innerHTML = '';
        var s = data.scoreOutOf100;
        var bar = el('div', 'pa-scorebar');
        var ring = el('div', 'pa-ring');
        ring.style.background = scoreColor(s);
        var num = el('b', null, String(s));
        ring.appendChild(num);
        ring.appendChild(el('span', null, T.outOf));
        bar.appendChild(ring);
        var meta = el('div', 'pa-scoremeta');
        meta.appendChild(el('h4', null, T.scoreLabel));
        meta.appendChild(el('div', 'pa-url', data.url));
        bar.appendChild(meta);
        result.appendChild(bar);
        var gaps = (data.topGaps || []).slice(0, 4);
        if (gaps.length) {
            result.appendChild(el('div', 'pa-gapslabel', T.gapsLabel));
            var ul = el('ul', 'pa-gaps');
            gaps.forEach(function(g) {
                ul.appendChild(el('li', null, ja ? g.textJa || g.text : g.text));
            });
            result.appendChild(ul);
        }
        result.appendChild(el('p', 'pa-fix', T.fixLine));
        var cta = el('a', 'pa-cta', T.cta);
        cta.href = '#contact';
        result.appendChild(cta);
        result.className = 'pa-result pa-show';
    }
    function mount() {
        injectStyles();
        var section = render();
        // Place the checker right before the contact section so the CTA flows
        // straight into the form; fall back to end of <body>.
        var contact = document.getElementById('contact') || document.querySelector('.contact-form');
        if (contact) {
            var host = contact.closest('section') || contact;
            host.parentNode.insertBefore(section, host);
        } else document.body.appendChild(section);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
})();

//# sourceMappingURL=repo.cbc04632.js.map
